<script setup lang="ts">
import { BuildingOfficeIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsCompanyResult } from '@/api/omnisearchApi'

const props = defineProps<{
  item: OsCompanyResult
  query: string
}>()

const emit = defineEmits<{ navigate: [] }>()

function getHref(): string | null {
  // Fiche client 360° (pilotée par l'uuid de la company boost-suite).
  if (props.item.uuid) return `/client/${props.item.uuid}`
  // Repli : ancienne fiche partner (id Odoo).
  if (props.item.referenceExterne) return `/partner/${props.item.referenceExterne}`
  return null
}

function handleClick() {
  const href = getHref()
  if (href) {
    emit('navigate')
    window.location.href = href
  }
}
</script>

<template>
  <button
    class="w-full flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-base-200 transition-colors text-left group"
    :class="getHref() ? 'cursor-pointer' : 'cursor-default opacity-70'"
    @click="handleClick"
  >
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
      <BuildingOfficeIcon class="w-4 h-4 text-blue-600 dark:text-blue-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p
        class="text-sm font-medium truncate text-base-content"
        v-html="highlight(item.name ?? '—', query)"
      />
      <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
        <span v-if="item.siren" class="text-xs text-base-content/60" v-html="'SIREN ' + highlight(item.siren, query)" />
        <span v-if="item.siret" class="text-xs text-base-content/60" v-html="'SIRET ' + highlight(item.siret, query)" />
        <span v-if="item.zip" class="text-xs text-base-content/60" v-html="highlight(item.zip, query)" />
        <span v-if="item.vat" class="text-xs text-base-content/60" v-html="'TVA ' + highlight(item.vat, query)" />
      </div>
    </div>
    <span v-if="!getHref()" class="text-xs text-base-content/40 self-center flex-shrink-0">pas de fiche</span>
    <span v-else class="text-xs text-base-content/40 self-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">→</span>
  </button>
</template>
